import { render, staticRenderFns } from "./TiEventEditing.vue?vue&type=template&id=2afdb563"
import script from "./TiEventEditing.vue?vue&type=script&lang=js"
export * from "./TiEventEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports